import { goto } from '$app/navigation';
import { navigating } from '$app/stores';
import { onDestroy } from 'svelte';

let state: unknown;

export function gotoWithTransitionState<T>(
  url: string,
  value: T,
  options?: { replaceState?: boolean; noscroll?: boolean; keepfocus?: boolean; state?: any },
): void {
  state = value;
  goto(url, options);
}

export function getTransitionState<T>(): T | undefined {
  return state as T | undefined;
}

export function setupClearTransitionState(): void {
  const unsubscribe = navigating.subscribe((value) => {
    if (value === null) {
      state = undefined;
    }
  });

  onDestroy(unsubscribe);
}

export function changeQueryParam(param: string, value: unknown): Promise<void> {
  const params = new URLSearchParams(window.location.search);
  params.set(param, String(value));
  return goto(`?${params.toString()}`);
}
